import { atom } from 'recoil';

export interface IClosetForm {
  newClosetName?: string;
  newTitle?: string;
  newSubTitle?: string;
  newTag?: string;
  newDescription?: string;
}

export const closetFormState = atom<IClosetForm>({
  key: 'closetFormState',
  default: {},
});

export const noteState = atom({
  key: 'noteState',
  default: '',
});

export const ddayTextState = atom({
  key: 'ddayTextState',
  default: '',
});

export const representativePhotocardIDState = atom({
  key: 'representativePhotocardIDState',
  default: '',
});
